import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Input, Button, Form, Statistic, App, Row, Col, Typography } from "antd";
import { Regex, ActionType, API, Enum } from "../../resources/constants";
import language from "../../resources/languages/fa_IR";

// Contexts
import GlobalContext from "../../contexts/global";
import AxiosContext from "../../contexts/axios";

// Interfaces
import { AxiosError } from "../../interfaces/axios"

const { Title } = Typography
const { Countdown } = Statistic
const { Components: { SignIn }, App: AppLanguage, Validation, Share, Message: MessageLanguage } = language
const { isNumber } = Regex
const { SET_USER, SET_FORM, SET_OPEN_DRAWER } = ActionType
const { USER_MANAGEMENT_AUTH_VERIFY_CODE, USER_MANAGEMENT_AUTH_SIGN_IN, USER_MANAGEMENT_AUTH_PROFILE } = API
const { Form: FormEnum, Message } = Enum
const mobileMinutesLeft = process.env.REACT_APP_MOBILE_MINUTES_LEFT
const urlParams = new URLSearchParams(window.location.search)

export default function Index() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const [countdown, setCountdown] = useState<boolean>(false)
    const { dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    useEffect(() => {
      // To disable submit button at the beginning.
      forceUpdate({});
    }, []);

    const onFinish = ({ username, password }: { username: string, password: string }) => {
      axios.post(USER_MANAGEMENT_AUTH_SIGN_IN, { username: username.substring(1), password }).then((response: { data: { accessToken: string }}) => {
        const { data: { accessToken } } = response
        Cookies.set('accessToken', accessToken, { expires: 365 })
        axios.get(USER_MANAGEMENT_AUTH_PROFILE).then((response: { data: { complete: boolean } }) => {
          const { data: user } = response
          dispatch({ type: SET_USER , payload: { user }})
          if (user.complete) {
            if (urlParams.get('payment')) {
                dispatch({ type: SET_FORM , payload: { form: FormEnum.PAYMENT }})
                dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
            } else dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})
          } else
            dispatch({ type: SET_FORM , payload: { form: FormEnum.PROFILE }})
          message.success(MessageLanguage[Message.SIGN_IN_PROFILE]).then(response => response)
        })
      }).catch( (error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
      })
    };

    return (
      <>
          <Title level={1} className={'safar30-title'}>{AppLanguage.title}</Title>
          <Title level={2} className={'safar30-title'}>{AppLanguage.description}</Title>
          <Form form={form} name="sign-in" onFinish={onFinish} autoComplete="off">
              <Form.Item
                  name="username"
                  rules={[
                      { required: true, message: `${SignIn.mobile} ${Validation.required}` },
                      { pattern: isNumber, message: `${SignIn.mobile} ${Validation.pattern}` },
                      { len: 11, message: `${SignIn.mobile} 11 ${Validation.length}` },
                  ]}
              >
                  <Input type="tel" maxLength={11} disabled={countdown} placeholder={SignIn.mobile} />
              </Form.Item>
              <Row gutter={8}>
                  <Col span={14}>
                      <Form.Item
                          name="password"
                          rules={[
                              { required: true, message: `${SignIn.oneTimeCode} ${Validation.required}` },
                              { pattern: isNumber, message: `${SignIn.oneTimeCode} ${Validation.pattern}` },
                              { len: 5, message: `${SignIn.oneTimeCode} 5 ${Validation.length}` },
                          ]}
                      >
                          <Input type="tel" maxLength={5} placeholder={SignIn.oneTimeCode} />
                      </Form.Item>
                  </Col>
                  <Col span={10}>
                      {
                          !countdown ? (
                              <Form.Item shouldUpdate>
                                  {() => (
                                      <Button type="primary" disabled={!form.getFieldValue('username') || !!form.getFieldsError(['username']).filter(({ errors }) => errors.length).length} ghost block onClick={() => {
                                          axios.get(`${USER_MANAGEMENT_AUTH_VERIFY_CODE}/${form.getFieldValue('username').substring(1)}`).then((response: any) => {
                                              form.resetFields(['password'])
                                              message.success(MessageLanguage[Message.VERIFY_CODE_SENT]).then(response => response )
                                              setCountdown(true)
                                          }).catch( (error: AxiosError) => {
                                              const { response: { data } } = error;
                                              // @ts-ignore
                                              message.error(MessageLanguage[data.message]).then(response => response )
                                          })
                                      }}>
                                          { SignIn.receiveCode }
                                      </Button>
                                  )}
                              </Form.Item>
                          ) : (
                              <Form.Item>
                                  <Button type="primary" disabled ghost block>
                                      <Countdown value={Date.now() + Number(mobileMinutesLeft) * 60 * 1000} format="ss" onFinish={() => {
                                          setCountdown(false)
                                      }} />
                                  </Button>
                              </Form.Item>
                          )
                      }

                  </Col>
              </Row>
              <Form.Item shouldUpdate>
                  {() => (
                      <Button
                          type="primary"
                          block
                          htmlType="submit"
                          disabled={!form.getFieldValue('username') || !form.getFieldValue('password') || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
                      >
                          { SignIn.signIn }
                      </Button>
                  )}
              </Form.Item>
          </Form>
          <Row gutter={8} className={'logos'}>
              <Col span={8}>
                  <a
                      target='_self'
                      href='http://safar30.ir/'
                  >
                      <img
                          src={require('../../resources/media/logo-resize/safar30.png')}
                          alt={Share.safar30}
                      />
                  </a>
              </Col>
              <Col span={8}>
                  <a
                      target='_blank'
                      href='https://www.rmto.ir/'
                  >
                      <img
                          src={require('../../resources/media/logo-resize/rmto.png')}
                          alt={Share.rmto}
                      />
                  </a>
              </Col>
              <Col span={8}>
                  <a
                      referrerPolicy='origin'
                      target='_blank'
                      href='https://trustseal.enamad.ir/?id=436186&Code=kKmpA6fNhBAl26JVmDGE1HCJ0mVvrP2M'
                  >
                      <img
                          referrerPolicy='origin'
                          // src='https://trustseal.enamad.ir/logo.aspx?id=436186&Code=kKmpA6fNhBAl26JVmDGE1HCJ0mVvrP2M'
                          src={require('../../resources/media/logo-resize/enamad.png')}
                          alt={Share.enamad}
                          // @ts-ignore
                          Code='kKmpA6fNhBAl26JVmDGE1HCJ0mVvrP2M'
                      />
                  </a>
              </Col>
          </Row>
          <Row gutter={8} className={'logos'}>
              <Col span={8}>
                  <a
                      target='_blank'
                      href='https://pep.co.ir/'
                  >
                      <img
                          src={require('../../resources/media/logo-resize/pep.png')}
                          alt={Share.pep}
                      />
                  </a>
              </Col>
              <Col span={8}>
                  <a
                      target='_blank'
                      href='https://www.sep.ir/'
                  >
                      <img
                          src={require('../../resources/media/logo-resize/sep.png')}
                          alt={Share.sep}
                      />
                  </a>
              </Col>
              <Col span={8}>
                  <a
                      target='_blank'
                      href='https://www.zarinpal.com/'
                  >
                      <img
                          src={require('../../resources/media/logo-resize/zarinpal.png')}
                          alt={Share.zarinpal}
                      />
                  </a>
              </Col>
          </Row>
      </>
    )
}
